import PropTypes from "prop-types";
import React from "react";
import { Trans } from "react-i18next";
import { Modal } from "nacre/modal";

export default function ConfirmModal({
	// legacy props
	isOpen,
	onDeclined,
	onValidated,
	// same props as nacre/modal
	open,
	onValidate,
	onCancel,
	...props
}) {
	return <Modal
		open={ open !== undefined ? open : isOpen }
		onValidate={ onValidate || onValidated }
		onCancel={ onCancel || onDeclined }
		cancelLabel={ <Trans i18nKey="common.decline">Decline</Trans> }
		validateLabel={ <Trans i18nKey="common.validate">Validate</Trans> }
		{ ...props }
	/>;
}

ConfirmModal.propTypes = {
	isOpen: PropTypes.bool,
	open: PropTypes.bool,
	onDeclined: PropTypes.func,
	onValidated: PropTypes.func,
	onValidate: PropTypes.func,
	onCancel: PropTypes.func,
};
